import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "h5-how-to-play-banner"
};
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = {
  class: "h5-how-to-play-banner__icon",
  "aria-hidden": "true"
};
const _hoisted_4 = {
  class: "h5-how-to-play-banner__label"
};
const _hoisted_5 = ["aria-label"];
import { watch, onUnmounted } from 'vue';
import { useStorage } from '@vueuse/core';
import { Close, InfoFilled } from '@element-plus/icons-vue';

/** 条总高 52：顶部文案区 + 底部留白（给创建 + 上探），文案顶置 */
const BANNER_HEIGHT = '52px';
const STORAGE_KEY = 'ds-h5-how-to-play-dismissed';
export default {
  __name: 'H5HowToPlayBanner',
  emits: ['open'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const dismissed = useStorage(STORAGE_KEY, false);
    function syncBannerHeight(visible) {
      if (typeof document === 'undefined') return;
      document.documentElement.style.setProperty('--mobile-h5-how-to-play-banner-height', visible ? BANNER_HEIGHT : '0px');
    }
    function dismiss() {
      dismissed.value = true;
    }
    watch(dismissed, value => {
      syncBannerHeight(!value);
    }, {
      immediate: true
    });
    onUnmounted(() => {
      syncBannerHeight(false);
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return !_unref(dismissed) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
        type: "button",
        class: "h5-how-to-play-banner__main",
        "aria-label": _ctx.$t('nav.howToPlay'),
        onClick: _cache[0] || (_cache[0] = $event => emit('open'))
      }, [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_unref(InfoFilled))]),
        _: 1
      })]), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('nav.howToPlay')), 1)], 8, _hoisted_2), _createElementVNode("button", {
        type: "button",
        class: "h5-how-to-play-banner__close",
        "aria-label": _ctx.$t('nav.howToPlayClose'),
        onClick: dismiss
      }, [_createVNode(_component_el_icon, {
        "aria-hidden": "true"
      }, {
        default: _withCtx(() => [_createVNode(_unref(Close))]),
        _: 1
      })], 8, _hoisted_5)])) : _createCommentVNode("", true);
    };
  }
};